export const sortClaims = (claims) =>
  [...claims].sort((a, b) => {
    const dateA = new Date(a.ReceivedDate || a.Modified || a.Created);
    const dateB = new Date(b.ReceivedDate || b.Modified || b.Created);
    return dateB - dateA;
  });
